import type { ReactElement } from 'react';

import { useTotalClinicDataStore } from '../../../stores/usePaginacao';
import DentistsFound from './DentistsFound';
import InfoBox from './InfoBox';

export default function MapStage(): ReactElement {
  const totalClinics = useTotalClinicDataStore(x => x.data);
  const total = totalClinics || 0;

  return (
    <>
      <InfoBox total={total} />
      <div className="mt-5 w-full min-[1000px]:p-2">
        <DentistsFound />
      </div>
      {total > 0 && (
        <div className="mt-6 flex justify-center">
          <img
            src="/assets/images/legenda-ans.png"
            alt="Legenda ANS"
            className="max-w-full"
          />
        </div>
      )}
    </>
  );
}
